import React from 'react';
import _ from 'lodash';
import Grid from '../../../../grid/Grid';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import NcDmvHearingFeeService from '../../../../../service/NcDmvHearingFeeService';
import NcDmvHearingFeeModal from './NcDmvHearingFeeModal';

export default class NcDl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      headers: [],
    };

    this.comboFields = [
      {
        value: 'driversLicenseNumber',
        display: 'Driver License Number',
      },
      {
        value: 'customerId',
        display: 'Customer Id',
      },
    ];
  }

  onHearingFeeSelect(row) {
    const { rows = [], } = this.state;
    const selectedHearingFee = rows.find(order => order.raw.id === row.id);
    this.setState({
      selectedHearingFee: selectedHearingFee.raw,
    });
  }

  getHearingFees(event) {
    const { search, combo, } = event;
    this.reset();

    const vm = this;
    const headers = [];
    const rows = [];
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = 'ncdmv_hearing_fee';

    const allowedKeys = [
      'id',
      'driversLicenseNumber',
      'customerId',
      'paymentAmount',
      'paymentTransactionId',
      'paymentDate',
    ];

    NcDmvHearingFeeService.getNcDmvHearingFeesBySearchCriteria(criteria)
      .then((response) => {
        const { hearingFees, } = response.data;
        if (hearingFees.length > 0) {
          allowedKeys.forEach((allowedKey) => {
            headers.push({
              value: allowedKey,
              display: _.startCase(allowedKey),
            });
          });
          hearingFees.forEach((hearingFee) => {
            const filtered = _.pick(hearingFee, allowedKeys);
            rows.push({
              value: Object.values(filtered),
              raw: hearingFee,
            });
          });
        }
        vm.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  formatSelectedRowDisplay = (hearingFee) => {
    if (!hearingFee) {
      return null;
    }

    return (
      <div>
        <p>{`Selected ID: ${hearingFee.id}`}</p>
        <hr />
        <NcDmvHearingFeeModal selectedHearingFee={hearingFee} />
      </div>
    );
  };

  reset() {
    this.setState({
      rows: [],
      headers: [],
      selectedHearingFee: null,
    });
  }

  render() {
    const {
      headers = [],
      rows = [],
      selectedHearingFee,
    } = this.state;

    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          onClick={data => this.getHearingFees(data)}
        />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Hearing Fees">
            <Grid
              headers={headers}
              rows={rows}
              style={{ maxHeight: '800px', overflowY: 'auto', }}
              onRowSelect={data => this.onHearingFeeSelect(data)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedHearingFee)}
        </div>
      </div>
    );
  }
}
